import { render, staticRenderFns } from "./workerCertificateDoctorPra.vue?vue&type=template&id=4c416040&scoped=true&"
import script from "./workerCertificateDoctorPra.vue?vue&type=script&lang=js&"
export * from "./workerCertificateDoctorPra.vue?vue&type=script&lang=js&"
import style0 from "./workerCertificateDoctorPra.vue?vue&type=style&index=0&id=4c416040&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c416040",
  null
  
)

export default component.exports